import { createFileRoute } from '@tanstack/react-router';
import { ExternalContactsListPage } from '@/pages/organization/external-contacts/ExternalContactsListPage';
import { dataTableSearchSchema } from '@/lib/validation/dataTableSearchSchema';

export const Route = createFileRoute('/$slug/organization/external-contacts/')({
  component: ExternalContactsListPage,
  validateSearch: dataTableSearchSchema({})
});
